const ERRORS = {
    default: {
        title: '',
        message: "We're sorry. We are unable to complete your request. Please try again."
    },
    userIdUpdateErr: {
        title: "It’s not you. It’s us!",
        message: "We are experiencing a technical error and we’re working on it. Please try again later."
    },
    myAccountPageErr: {
        title: "Uh-Oh!",
        message: "We’ve experienced a technical issue. Please try again."
    },
    editInterestedPartyErr:{
        title:"We've received your request to edit an Interested party.",
        message:"Please allow one business day for the update."
    },
    OAASubmitPageErr: {
        title: "We've received your request to open an additional account",
        message: "Please allow one business day for your new account to set up."
    },
    error504:{
        title:"We've received your request",
        message:"Please allow one business day to see the update appear in your account. No further action is needed"
    },
    technicalErr:{
        title:"Alert",
        message:"Technical error occured. Please try again"
    }
}

export default {
    ERRORS
};